import { HelpMessage } from 'utils/constants'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { NonUserEmail } from '../../../NonUserEmailsTableContext'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<NonUserEmail>[] => {
  return [
    {
      title: 'Label',
      render: ({ label }) => label,
      help: HelpMessage.Administration.NonUserEmails.Label,
      sort: { with: 'key', key: 'label', default: 'ascend' },
      filter: {
        type: 'search',
        with: 'key',
        key: 'label',
      },
    },
    useOptionalDescriptionColumn('Non User Email'),
    {
      title: 'Email Address',
      render: ({ address }) => address,
      help: HelpMessage.Administration.NonUserEmails.Email,
      sort: { with: 'key', key: 'address' },
      filter: {
        type: 'search',
        with: 'key',
        key: 'address',
      },
    },
  ]
}
